import { UPLOADS, ebook, pdf } from '@/content/ebookBuilder'
import type { Ebook } from '@/content/ebookBuilder'

export const added: Ebook = ebook(
  // Confirmed, and this time the title rule was right: the reference
  // screenshots for this book's page came from
  // `digitopia.co/impact-labs/ebooks/transforming-pain-into-power/` on
  // 2026-08-28 and carry that address in their filenames.
  'transforming-pain-into-power',
  'Transforming Pain into Power',
  `${UPLOADS}/2024/09/digitopia-transformpain-web-02-400x400.jpg`,
  {
    confirmed: true,
    download: pdf('ebc82665-fef9-4e2f-8f12-b1f54703d0a6-Transforming Pain into Power.pdf'),
    // Designed as its own written page on 2026-08-28, the seventh after
    // Transform Better, Agentic AI, Sustainability Innovation, Measurement,
    // AI in Fashion Retail and The Leader's Guide to Generative AI — so the
    // card goes there and `prerender.tsx` skips it, rather than generating
    // this template over the top of it.
    href: '/en/impact-labs/ebooks/transforming-pain-into-power',
  },
)

/** Its place in the library grid — the order the imported index listed them. */
export const order = 9
